import { render } from "./KnowledgeCourseDisplay.vue?vue&type=template&id=d16aa2f2&scoped=true"
import script from "./KnowledgeCourseDisplay.vue?vue&type=script&lang=js"
export * from "./KnowledgeCourseDisplay.vue?vue&type=script&lang=js"

import "./KnowledgeCourseDisplay.vue?vue&type=style&index=0&id=d16aa2f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d16aa2f2"]])

export default __exports__